<template>
    <div class="container">
        <div class="fixed-cards">
            <!-- 前仓详情详情的表单 -->
            <el-card shadow="hover" class="card">
                <div slot="header" class="clearfix">
                    <span>前仓详情信息:</span>
                </div>
                <div class="card-content">
                    <el-row>
                        <el-col :span="24"><strong>关联店铺名称:</strong> {{ info.shopName }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6"><strong>前仓名称:</strong> {{ info.warehouseName }}</el-col>
                        <el-col :span="6"><strong>前仓手机号:</strong> {{ info.warehouseMobile }}</el-col>
                        <el-col :span="12"><strong>前仓地址:</strong> {{ info.address }}</el-col>
                    </el-row>
                </div>
            </el-card>
        </div>
        <div class="fixed-cards">
            <el-card shadow="hover" class="card">
                <div slot="header" class="clearfix">
                    <span>前仓商品列表:</span>
                </div>
                <basic-container>
                    <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page"
                        ref="crud" @search-change="searchChange" @refresh-change="refreshChange(page)"
                        @selection-change="handleSelectionChange" @size-change="pageSizeChange"
                        @row-update="handleUpdate" @current-change="pageChange">
                        <template slot-scope="scope" slot="menuLeft">
                            <el-button size="mini" type="text" @click="handleAdd" icon="el-icon-plus">
                                入库
                            </el-button>
                            <el-button size="mini" type="text" @click="handleAddCeiling" icon="el-icon-plus">
                                吊顶入库
                            </el-button>
                        </template>
                        <template slot-scope="scope" slot="goodsNameForm">
                            <el-select v-model="goods" placeholder="请选择商品" required value-key="id">
                                <el-option v-for="goods in goodsList" :key="goods.id" :label="goods.name"
                                    :value="goods"></el-option>
                            </el-select>
                        </template>
                        <template slot-scope="scope" slot="unStockQuantity">
                            <span>{{ scope.row.unStockQuantity ? scope.row.unStockQuantity : 0 }}</span>
                        </template>
                        <!-- 操作按钮 -->
                        <template slot-scope="scope" slot="menu">
                            <!-- 查看 -->
                            <el-button size="mini" type="text" @click="handleView(scope.row.goodsId)"
                                icon="el-icon-view">
                                查看
                            </el-button>
                            <!-- 入库，只输入数量 -->
                            <el-button size="mini" type="text" @click="AddIncrease(scope.row.goodsId)"
                                icon="el-icon-plus">
                                入库
                            </el-button>
                        </template>
                    </avue-crud>
                </basic-container>
                <!-- 新增弹窗表单 -->
                <el-dialog title="入库" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false">
                    <el-form :model="form">
                        <el-table :data="form.items" border style="width: 100%; margin-top: 20px">
                            <el-table-column prop="goodsId" label="商品" min-width="150">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.goodsId" placeholder="请选择商品" required value-key="id"
                                        @change="updateSelectedGoods">
                                        <el-option v-for="goods in goodsList" :key="goods.id" :label="goods.name"
                                            :value="goods.id"
                                            :disabled="isGoodsSelected(goods.id, scope.row.goodsId)"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="num" label="数量" min-width="150">
                                <template slot-scope="scope">
                                    <el-input type="number" v-model="scope.row.num" placeholder="请输入数量" min="1"
                                        clearable></el-input>
                                </template>
                            </el-table-column>
                            <!-- 删除商品 -->
                            <el-table-column align="center" label="操作" width="150">
                                <template slot-scope="scope">
                                    <el-button type="danger" icon="el-icon-close" size="small"
                                        @click="delFormItem(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 动态添加表单项按钮 -->
                        <el-button type="text" icon="el-icon-plus" @click="addFormItem">添加商品</el-button>
                        <!-- 上传凭证 -->
                        <el-form-item label="上传凭证:">
                            <ImageUpload action="#" :multiple="true" :limit="5" @uploaded="handleUploaded"
                                :listTypeMode="listTypeMode" :uploaded-images="picUrl" />
                        </el-form-item>
                    </el-form>
                    <!-- 提交表单按钮 -->
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="cancelForm" icon="el-icon-close">取 消</el-button>
                        <el-button type="text" @click="submitForm" icon="el-icon-check">提交</el-button>
                    </div>
                </el-dialog>
                <!-- 新增吊顶弹窗表单 -->
                <el-dialog title="新增吊顶入库" :visible.sync="dialogVisibleCeiling" width="50%"
                    :close-on-click-modal="false">
                    <el-form :model="ceilingForm" ref="ceilingForm" :rules="ceilingRules">
                        <el-form-item label="选择产品" prop="items">
                            <ceiling-product-selector v-model="ceilingForm.items" :goods-list="ceilingGoodsList" />
                        </el-form-item>
                        <!-- 上传凭证 -->
                        <el-form-item label="上传凭证:">
                            <ImageUpload action="#" :multiple="true" :limit="5" @uploaded="handleCeilingUploaded"
                                :listTypeMode="listTypeMode" :uploaded-images="ceilingPicUrl" />
                        </el-form-item>
                    </el-form>
                    <!-- 提交表单按钮 -->
                    <div slot="footer" class="dialog-footer">
                        <el-button type="text" @click="cancelCeilingForm" icon="el-icon-close">取 消</el-button>
                        <el-button type="text" @click="submitCeilingForm" icon="el-icon-check">提交</el-button>
                    </div>
                </el-dialog>
                <!-- 入库弹窗表单 -->
                <el-dialog title="请输入数量" :visible.sync="dialogVisibleIncrease" width="50%"
                    :close-on-click-modal="false">
                    <el-form :model="formIncrease">
                        <el-table :data="formIncrease.items" border style="width: 100%; margin-top: 20px">
                            <el-table-column prop="num" label="入库数量" min-width="150">
                                <template slot-scope="scope">
                                    <el-input type="number" v-model="scope.row.num" placeholder="请输入数量" min="1"
                                        clearable></el-input>
                                </template>
                            </el-table-column>
                            <!-- 上传凭证 -->
                            <el-table-column prop="picUrl" label="上传凭证" min-width="150">
                                <template slot-scope="scope">
                                    <ImageUpload action="#" :multiple="true" :limit="5" @uploaded="handleUploadedPic"
                                        :inTable="true" :listTypeMode="listTypeMode"
                                        :uploaded-images="scope.row.picUrl" />
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form>
                    <!-- 提交表单按钮 -->
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="cancelFormIncrease" icon="el-icon-close">取 消</el-button>
                        <el-button type="text" @click="submitIncreaseForm" icon="el-icon-check">提交</el-button>
                    </div>
                </el-dialog>
            </el-card>
        </div>
    </div>
</template>
<script>
import { getWarehouseDetail, getGoodsListV2, increaseGoods, delGoods } from "@/api/salesCloud/warehouse";
import { findPureWaterGoodsByRootDepartIds, findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import { warehouseGoodsOption } from "@/const/salesCloud/warehouseGoodsOption";
import { getBusinessEntityList } from "@/api/salesCloud/businessEntity/businessEntity";
import ImageUpload from "@/components/imageUpload/ImageUpload";
import ceilingProductSelector from "./components/ceiling-product-selectator.vue";
export default {
    name: "warehouseDetails",
    components: {
        ImageUpload,
        ceilingProductSelector,
    },
    data() {
        return {
            info: {},
            tableOption: warehouseGoodsOption, //表格设置属性
            department: "", //店铺
            selectedGoods: [], // 存储已选商品的数组
            tableData: [], //表格的数据
            goodsList: [], //商品列表
            goods: {}, //商品
            picUrl: "", //上传凭证
            listTypeMode: "picture-card",
            tablePage: 1,
            tableLoading: false,
            loading: false,
            dialogVisible: false,
            dialogVisibleIncrease: false,
            formIncrease: {
                items: [{ num: '', warehouseId: this.$route.query.id, goodsId: '', type: "INCREASE", picUrl: "" }]
            },
            ids: "",
            point: {},
            form: {
                items: [{ num: '', warehouseId: this.$route.query.id, goodsId: '', type: "INCREASE" }]
            },
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10 //每页显示多少条
            },
            ceilingForm: {
                items: [{
                    goodsId: [],
                    num: 1
                }],
                warehouseId: this.$route.query.id,
                type: "INCREASE"
            },
            ceilingPicUrl: [],
            ceilingGoodsList: [],
            ceilingRules: {
                items: [
                    {
                        required: true,
                        message: '请至少选择一个商品',
                        trigger: 'change'
                    }
                ],
                picUrl: [
                    {
                        required: true,
                        message: '请上传凭证',
                        trigger: 'change'
                    }
                ]
            },
            dialogVisibleCeiling: false,
            businessEntityList: [], // 经营主体列表
        };
    },
    methods: {
        // 加载级联商品数据，并初始化 selectedGoods
        loadCeilingGoodsList() {
            const type = "HANG_CEILING";
            findPureWaterGoodsByRootDepartId(type).then(res => {
                if (res.code === "200") {
                    const raw = JSON.parse(res.data);
                    // 将数据转换为级联选择器需要的格式
                    this.ceilingGoodsList = raw.map(item => ({
                        value: item.id,
                        label: item.name,
                        children: item.filters ? item.filters.map(f => ({
                            value: f.id,
                            label: f.value
                        })) : []
                    }));
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        handleCeilingUploaded(url) {
            this.ceilingPicUrl = url;
        },
        cancelCeilingForm() {
            this.dialogVisibleCeiling = false;
            this.ceilingPicUrl = [];
            this.ceilingForm = {
                items: [{
                    goodsId: [],
                    num: 1
                }],
                warehouseId: this.$route.query.id,
                type: "INCREASE"
            };
            if (this.$refs.ceilingForm) {
                this.$refs.ceilingForm.resetFields();
            }
        },
        submitCeilingForm() {
            this.$refs.ceilingForm.validate(valid => {
                if (!valid) {
                    return;
                }
                if (!this.ceilingForm.items || this.ceilingForm.items.length === 0) {
                    this.$message({
                        showClose: true,
                        message: "请至少选择一个商品",
                        type: "warning"
                    });
                    return;
                }
                // 验证所有商品是否都已选择
                const invalidItems = this.ceilingForm.items.filter(item => !item.goodsId || item.goodsId.length === 0);
                if (invalidItems.length > 0) {
                    this.$message({
                        showClose: true,
                        message: "请选择所有商品",
                        type: "warning"
                    });
                    return;
                }
                // 验证数量
                const invalidNums = this.ceilingForm.items.filter(item => !item.num || item.num < 1);
                if (invalidNums.length > 0) {
                    this.$message({
                        showClose: true,
                        message: "请确保所有商品数量有效",
                        type: "warning"
                    });
                    return;
                }
                // 准备提交数据
                let params = this.ceilingForm.items.map(item => ({
                    goodsId: Array.isArray(item.goodsId) ? item.goodsId[item.goodsId.length - 1] : item.goodsId,
                    num: item.num,
                    warehouseId: this.ceilingForm.warehouseId,
                    type: this.ceilingForm.type,
                    picUrl: this.ceilingPicUrl ? this.ceilingPicUrl.map(url => url.url).join(",") : ""
                }));
                increaseGoods(params).then((res) => {
                    if (res.code == "200") {
                        this.$message({
                            showClose: true,
                            message: "吊顶入库成功",
                            type: "success"
                        });
                        this.cancelCeilingForm();
                        this.getWarehouseEntryDetailList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message ? res.message : "入库失败,请重试",
                            type: "error"
                        });
                    }
                });
            });
        },
        handleUploadedPic(url) {
            // this.picUrl为每次上传的url用逗号拼接
            this.formIncrease.items[0].picUrl = url;
        },
        handleUploaded(url) {
            this.picUrl = url;
            this.tableLoading = false;
        },
        clean() {
            this.point = {};
            this.department = "";
            this.picUrl = "";
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = this.page.currentPage;
            params.size = pageSize;
            params.warehouseId = this.$route.query.id;
            this.downloadData = params;
            getGoodsListV2(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;
            this.downloadData = params;
            params.warehouseId = this.$route.query.id;
            getGoodsListV2(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            if (!params.businessEntityId) {
                this.$message({
                    showClose: true,
                    message: "请选择经营主体",
                    type: "warning"
                });
                return;
            }
            this.tableLoading = true;
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            params.warehouseId = this.$route.query.id;
            getGoodsListV2(params).then(res => {
                if (res.code != 500) {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                    this.tableData = [];
                }
            });
        },
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            this.downloadData = params;
            params.warehouseId = this.$route.query.id;
            if (!params.businessEntityId) {
                this.$message({
                    showClose: true,
                    message: "请选择经营主体",
                    type: "warning"
                });
                this.tableLoading = false;
                return;
            }
            getGoodsListV2(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize
                };
                this.tableLoading = false;
            });
        },
        /**
             * @title 打开入库窗口
             * @detail 调用crud的handleadd方法即可
             *
             **/
        handleAdd() {
            this.clean();
            this.dialogVisible = true;
        },
        AddIncrease(id) {
            this.dialogVisibleIncrease = true;
            this.formIncrease.items[0].goodsId = id;
        },
        handleAddCeiling() {
            this.ceilingForm = {
                items: [{
                    goodsId: [],
                    num: 1
                }],
                warehouseId: this.$route.query.id,
                type: "INCREASE"
            };
            this.ceilingPicUrl = [];
            this.dialogVisibleCeiling = true;
        },
        cancelFormIncrease() {
            this.dialogVisibleIncrease = false;
            this.formIncrease.items = [{ num: '', warehouseId: this.$route.query.id, goodsId: '', type: "INCREASE", picUrl: "" }];
        },
        // 更新已选商品的数组
        updateSelectedGoods() {
            this.selectedGoods = this.form.items.map((item) => item.goodsId).filter(Boolean);
        },
        // 判断商品是否已被选择，排除当前行的商品
        isGoodsSelected(goodsId, currentGoodsId) {
            return this.selectedGoods.includes(goodsId) && goodsId !== currentGoodsId;
        },
        addFormItem() {
            if (this.selectedGoods.length === this.goodsList.length || this.form.items.length >= this.goodsList.length) {
                this.$message({
                    showClose: true,
                    message: "不能再添加商品了",
                    type: "warning"
                });
                return;
            }
            this.form.items.push({ num: '', warehouseId: this.$route.query.id, goodsId: '', type: "INCREASE" });
        },
        delFormItem(index) {
            this.form.items.splice(index, 1);
            this.updateSelectedGoods();
        },
        cancelForm() {
            this.dialogVisible = false;
            this.picUrl = "";
            this.form.items = [{ num: '', warehouseId: this.$route.query.id, goodsId: '', type: "INCREASE" }];
        },
        submitForm() {
            let params = this.form.items;
            // 将图片地址拼接到params每一项产品中
            params.forEach(item => {
                item.picUrl = this.picUrl.map(url => url.url).join(",") ? this.picUrl.map(url => url.url).join(",") : "";
            });
            increaseGoods(params).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "入库成功",
                        type: "success"
                    });
                    // 重置表单
                    this.form.items = [{ num: '', warehouseId: this.$route.query.id, goodsId: '', type: "INCREASE" }];
                    this.dialogVisible = false;
                    this.getGoodsListV2();
                } else {
                    setTimeout(() => {
                        this.$message({
                            showClose: true,
                            message: res.message ? res.message : '入库失败,请重试',
                            type: "error"
                        });
                    }, 1000)
                }
            });
        },
        submitIncreaseForm() {
            let params = this.formIncrease.items.map(item => {
                return {
                    ...item,
                    picUrl: item.picUrl.map(url => url.url).join(",") ? item.picUrl.map(url => url.url).join(",") : ""
                };
            });
            increaseGoods(params).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "入库成功",
                        type: "success"
                    });
                    // 重置表单
                    this.formIncrease.items = [{ num: '', warehouseId: this.$route.query.id, goodsId: '', type: "INCREASE", picUrl: "" }];
                    this.dialogVisibleIncrease = false;
                    this.getGoodsListV2();
                } else {
                    setTimeout(() => {
                        this.$message({
                            showClose: true,
                            message: res.message ? res.message : '入库失败,请重试',
                            type: "error"
                        });
                    }, 1000)
                }
            });
        },
        handleEdit(row, index) {
            this.clean();
            this.$refs.crud.rowEdit(row, index);
            this.department = {
                id: row.shopId,
                shopName: row.shopName
            };
            this.point = {
                address: row.address,
                location: {
                    lng: row.longitude,
                    lat: row.latitude
                }
            };
        },
        handleUpdate(form, index, done, loading) {
            let params = {
                ...form,
                id: form.id,
                shopId: this.department.id,
                warehouseGoodsName: form.warehouseGoodsName,
                warehouseGoodsMobile: form.warehouseGoodsMobile,
                address: this.point.address,
                longitude: this.point.location.lng,
                latitude: this.point.location.lat,
            };
            const isEdit = true;
            increaseGoods(params, isEdit).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: "success"
                    });
                    done();
                    this.getGoodsListV2();
                } else {
                    setTimeout(() => {
                        this.$message({
                            showClose: true,
                            message: res.message ? res.message : '编辑失败,请重试',
                            type: "error"
                        });
                        loading();
                    }, 1000)
                }
            });
        },
        handleView(goodsId) {
            //跳转到详情页面查看
            this.$router.push({
                path: "/salesCloud/warehouse/goosDetailsView",
                query: {
                    goodsId,
                    warehouseId: this.$route.query.id
                },
            });
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange(val) {
            let ids = val.map(item => {
                return item.id;
            });
            this.ids = ids.join(",");
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel(row) {
            let ids = "";
            ids = this.ids;
            if (row) {
                ids = row.id;
                this.$confirm(`您确定删除该条数据吗？`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        delGoods(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功删除",
                                        type: "success"
                                    });
                                    this.getGoodsListV2();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message ? res.message : '删除失败,请重试',
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            } else {
                if (!ids) {
                    this.$message({
                        showClose: true,
                        message: "未选中任何数据",
                        type: "error"
                    });
                    return;
                }
                let length = ids.split(",").length;
                this.$confirm(
                    `共选中${length}条数据吗，您确定批量删除吗？`,
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                )
                    .then(() => {
                        delGoods(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功",
                                        type: "success"
                                    });
                                    this.getGoodsListV2();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            }
        },
        getGoodsListV2() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize,
                warehouseId: this.$route.query.id
            };
            this.downloadData = params;
            getGoodsListV2(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            });
        },
        findPureWaterGoodsByRootDepartIds() {
            findPureWaterGoodsByRootDepartIds().then((res) => {
                let data = JSON.parse(res.data);
                if (data == null) {
                    this.goodsList = [];
                } else {
                    this.goodsList = data;
                }
            });
        },
        // 获取经营主体列表
        async getBusinessEntities() {
            try {
                const params = {
                    page: 1,
                    size: 100, // 一次获取所有经营主体
                    entityName: ''
                };
                const res = await getBusinessEntityList(params);
                const data = JSON.parse(res.data);
                // 格式化经营主体数据为字典格式
                const businessEntities = data.rows.map(item => ({
                    label: item.entityName,
                    value: item.id
                }));
                // 将经营主体数据赋值给表格选项中的dicData
                const businessTypeColumn = this.tableOption.column.find(col => col.prop === 'businessEntityId');
                if (businessTypeColumn) {
                    businessTypeColumn.dicData = businessEntities;
                }
                this.businessEntityList = businessEntities;
            } catch (error) {
                console.log('detailEntry.vue ~ line: 758 ~ error ->', error);
            }
        },
        goBack() {
            this.$router.go(-1);
        },
    },
    created() {
        // 获取路由参数中的前仓ID
        const rowId = this.$route.query.id;
        // 使用前仓ID获取前仓信息
        getWarehouseDetail(rowId).then((res) => {
            this.info = JSON.parse(res.data);
        });
        // this.getGoodsListV2();
        this.findPureWaterGoodsByRootDepartIds();
        this.loadCeilingGoodsList();
        this.getBusinessEntities(); // 获取经营主体列表
    },
};
</script>
<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    min-height: 80%;
    box-sizing: border-box;
    font-family: fangsong;
    font-size: large;
}

.fixed-cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.card-content {
    padding: 20px;
}

/* 确保表格的字体与其他部分一致 */
.el-table {
    font-family: fangsong;
    font-weight: bold;
    font-size: large;
}

.el-table th,
.el-table td {
    font-family: fangsong;
    font-size: large;
}

.el-table th {
    font-family: fangsong;
    font-size: large;
}
</style>
